// extracted by mini-css-extract-plugin
export default {"tabs":"Meter_tabs__O2lpe"};